// extracted by mini-css-extract-plugin
export default {"stage":"FixedScale_stage__BZ1gm"};